import { render, staticRenderFns } from "./ExamList.vue?vue&type=template&id=12d5d2b6"
import script from "./ExamList.vue?vue&type=script&lang=js"
export * from "./ExamList.vue?vue&type=script&lang=js"
import style0 from "./ExamList.vue?vue&type=style&index=0&id=12d5d2b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports